"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
* Created on 1.11.2018
*/

var immutable_1 = require("immutable");

var CodebookItem_1 = require("../../core/model/codebook/CodebookItem");

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");
/**
 * Represents types for promotion, such as leaflet, non-leaflet, catalogue.
 *
 * @author ZSr
 */


var PromotionTypes =
/*#__PURE__*/
function (_CodebookItem_1$Codeb) {
  _inherits(PromotionTypes, _CodebookItem_1$Codeb);

  /**
   * @param id
   * @param title the title of the format
   * @param externalId - used for export
   */
  function PromotionTypes(id, title) {
    var _this;

    var externalId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    _classCallCheck(this, PromotionTypes);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PromotionTypes).call(this, id, title, null, immutable_1.List(), externalId));
    _this.id = id;
    _this.title = title;
    _this.externalId = externalId;
    return _this;
  }

  return PromotionTypes;
}(CodebookItem_1.CodebookItem);

exports.PromotionTypes = PromotionTypes;
/** Name of code book for generic code book API. */

PromotionTypes.CODEBOOK_NAME = 'promotions.types';
/** External id of Promotion Types */

PromotionTypes.EXT_ID_LEAFLET = '1';
PromotionTypes.EXT_ID_NON_LEAFLET = '2';
PromotionTypes.EXT_ID_CATALOGUE = '3';

PromotionTypes.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(CodebookItem_1.CodebookItem.name);
  return {
    id: builder.id('id'),
    title: builder.str('title'),
    description: builder.opt(builder.str('description')),
    flags: builder.listOf(builder.str('flags')),
    externalId: builder.opt(builder.str('externalId'))
  };
}();